import React, { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  Grid, Button, Switch,
  Slider, TextField, fade,
  Checkbox
} from '@material-ui/core'

import { makeStyles, withStyles } from '@material-ui/core/styles'

import { keyify2, handleTextPrepper } from '../../../../utils'

import TreeView from '@material-ui/lab/TreeView'
import UnitTree from '../../tools/UnitTree'

import UserBuildAlertsForm from './UserBuildAlertsForm'

import { postAlert, updateAlert, getAlertSettings } from '../../../../redux/actions'

import { NotificationToast } from '../../tools/Toast'

const useStyles = makeStyles((theme) => ({
  backBtn: {
    backgroundColor: '#8BB84B',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#588518'
    }
  },
  searchBtn: {
    color: '#fff',
    backgroundColor: '#3984f7',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  deleteBtn: {
    backgroundColor: theme.palette.action.active,
    margin: 'auto',
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.error.light
    }
  },
  greenBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    }
  },
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  blueBackground: {
    backgroundColor: '#007BFF',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  greenBackground: {
    backgroundColor: '#97b557',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  greyColor: {
    color: '#0000008A'
  },
  buildAlertsContainer: {
    height: 'auto',
    padding: theme.spacing(3),
    margin: 'auto',
    width: '100%'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  chip: {
    margin: 2
  },
  noLabel: {
    marginTop: theme.spacing(3)
  },
  editPaper: {
    backgroundColor: '#ffffff',
    maxHeight: '50em',
    overflow: 'scroll'
  },
  contentGridShow: {
  },
  contentGridHide: {
    maxHeight: '0px',
    transition: '0.5s',
    overflow: 'hidden'
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade('#868787', 0.15),
    '&:hover': {
      backgroundColor: fade('#868787', 0.25)
    },
    width: '100%'
  },
  searchIcon: {
    padding: theme.spacing(0, 1),
    height: '100%',
    position: 'absolute',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    padding: theme.spacing(2, 1, 2, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(5)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%'
  },
  wordList: {
    width: '100%'
  },
  unitTree: {
    width: 'fit-content',
    marginLeft: '-0.5em',
    minWidth: '12.5em'
  }
}))

const StyledSwitch = withStyles({
  switchBase: {
    color: 'white',
    '&$checked': {
      color: '#A4D164'
    },
    '&$checked + $track': {
      backgroundColor: '#A4D164'
    }
  },
  checked: {},
  track: {}
})(Switch)

const AccessSwitch = withStyles({
  switchBase: {
    color: '#417FF0',
    '&$switchBase + $track': {
      backgroundColor: '#417FF0'
    },
    '&$checked': {
      color: '#A4D164'
    },
    '&$checked + $track': {
      backgroundColor: '#A4D164'
    }
  },
  checked: {},
  track: {}
})(Switch)

const GreenCheckbox = withStyles({
  root: {
    color: '#595959',
    '&$checked': {
      color: '#A4D164'
    }
  },
  checked: {}
})((props) => <Checkbox color='default' {...props} />)

const CustomSlider = withStyles({
  root: {
    height: '5px'
  },
  rail: {
    backgroundImage: 'linear-gradient(to right, rgba(82,145,252,1) 20%, rgba(78,23,154,1) 20% 40%, rgba(245,216,24,1) 40% 60%, rgba(231,132,15,1) 60% 80%, rgba(211,17,17,1) 80%)',
    height: '5px'
  },
  track: {
    // backgroundImage: 'linear-gradient(to right, rgba(82,145,252,1) 20%, rgba(78,23,154,1) 20% 40%, rgba(231,132,15,1) 40% 60%, rgba(245,216,24,1) 60% 80%, rgba(211,17,17,1) 80%)',
    height: '5px'
  },
  mark: {
    height: '5px',
    width: '5px',
    backgroundColor: '#fff'
  },
  markActive: {
    opacity: 1,
    backgroundColor: '#fff'
  }
})(Slider)

const CustomTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'black'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#A4D164'
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#A4D164'
      }
    }
  }
})(TextField)

/**
 * Returns build alert form
 */
const UserBuildAlerts = (props) => {
  const {
    editing, editAlertID, handleBacktrack
  } = props

  const classes = useStyles()

  const dispatch = useDispatch()

  const TreeData = useSelector(state => state.auth.unitTree)

  const [selectedKeys, setSelectedKeys] = useState(keyify2(TreeData))
  const [selectedKey, setSelectedKey] = useState(TreeData[0].key)

  const Categories = useSelector(state => state.words.categories)
  const UsersList = useSelector(state => state.listings.users)
  const WorkstationsList = useSelector(state => state.listings.workstations)

  const [success, setSuccess] = useState(false)

  const [formData, setFormData] = useState({
    emailNotificationName: '',
    emailNotificationDesc: '',
    type: 'S',
    minSeverity: 1,
    maxSeverity: 100,
    keyboard: 1,
    application: 1,
    privateAlert: 1,
    limitByTimeframe: 0,
    timeframe: 0,
    count: 0,
    resetCount: 0,
    groupByWorkstation: 0,
    groupByUser: 0,
    categories: [],
    words: [],
    usernames: [],
    workstations: []
  })

  const handleDataSet = useCallback((data) => {
    const editData = data[0]
    const usernames = editData.users.map(user => {
      const tempUsernames = UsersList.find(u => u.userID === user.userID)
      return tempUsernames
    })

    const workstations = editData.workstations.map(workstation => {
      const tempWorkstations = WorkstationsList.find(w => w.workstationID === workstation.workstationID)
      return tempWorkstations
    })

    const categories = editData.categories.map(category => {
      const tempCategories = Categories.find(c => c.categoryID === category.categoryID)
      return tempCategories
    })

    setFormData({
      ...formData,
      emailNotificationName: editData.emailNotificationName,
      emailNotificationDesc: editData.emailNotificationDesc,
      type: editData.type,
      minSeverity: editData.minSeverity,
      maxSeverity: editData.maxSeverity,
      keyboard: editData.keyboard ? 1 : 0,
      application: editData.application ? 1 : 0,
      privateAlert: editData.privateAlert ? 1 : 0,
      limitByTimeframe: editData.limitByTimeframe,
      timeframe: editData.timeframe,
      count: editData.count,
      resetCount: editData.resetCount,
      groupByWorkstation: editData.groupByWorkstation,
      groupByUser: editData.groupByUser,
      categories: categories,
      words: editData.words,
      usernames: usernames,
      workstations: workstations
    })
    setSuccess(true)
  }, [UsersList, WorkstationsList, formData, Categories])

  useEffect(() => {
    if (editing === true && success === false) {
      dispatch(getAlertSettings(selectedKey, editAlertID, handleDataSet))
    }
  }, [dispatch, editAlertID, editing, success, handleDataSet, selectedKey])

  const marks = [
    { value: 20, label: '' },
    { value: 40, label: '' },
    { value: 60, label: '' },
    { value: 80, label: '' },
    { value: 100, label: '' }
  ]

  const handleNodeSelect = async (keySelected) => {
    if (selectedKey !== keySelected) {
      setSelectedKey(keySelected)
    }
  }

  const handleNodeAugment = async (key, children, isExpanded) => {
    if (isExpanded) {
      const tempSelected = [...selectedKeys]
      const keysToRemove = [key, ...keyify2(children)]

      const newSelected = tempSelected.filter((selectedKey) => keysToRemove.findIndex((removeKey) => removeKey === selectedKey) === -1)

      setSelectedKeys(newSelected)
    } else {
      const tempSelected = [...selectedKeys]
      const keysToAdd = [key, ...keyify2(children)]
      const addedKeys = []

      keysToAdd.forEach((addKey) => {
        if (tempSelected.findIndex((selectedKey) => selectedKey === addKey) === -1) {
          addedKeys.push(addKey)
        }
      })

      setSelectedKeys([...selectedKeys, ...addedKeys])
    }
  }

  const handleSave = () => {
    const unitID = selectedKey

    const users = [...formData.usernames]
    const newUsersArray = []
    users.forEach(user => {
      newUsersArray.push({ userID: user.userID })
    })

    const workstations = [...formData.workstations]
    const newWorkstationsArray = []
    workstations.forEach(workstation => {
      newWorkstationsArray.push({ workstationID: workstation.workstationID })
    })

    if (editing === false) {
      const alertData = {
        emailNotificationName: handleTextPrepper(formData.emailNotificationName),
        emailNotificationDesc: handleTextPrepper(formData.emailNotificationDesc),
        type: formData.type,
        keyboard: formData.keyboard ? 1 : 0,
        application: formData.application ? 1 : 0,
        limitByTimeframe: formData.limitByTimeframe ? 1 : 0,
        timeframe: formData.timeframe,
        count: formData.count,
        resetCount: formData.resetCount ? 1 : 0,
        groupByWorkstation: formData.groupByWorkstation ? 1 : 0,
        groupByUser: formData.groupByUser ? 1 : 0,
        privateAlert: formData.privateAlert ? 1 : 0,
        minSeverity: formData.minSeverity,
        maxSeverity: formData.maxSeverity,
        categories: [...formData.categories],
        words: [...formData.words],
        usernames: [...newUsersArray],
        workstations: [...newWorkstationsArray]
      }
      dispatch(postAlert(alertData, unitID, fireSuccess, fireFailure))
    } else if (editing === true) {
      const alertData = {
        emailNotificationName: handleTextPrepper(formData.emailNotificationName),
        emailNotificationDesc: handleTextPrepper(formData.emailNotificationDesc),
        type: formData.type,
        keyboard: formData.keyboard ? 1 : 0,
        application: formData.application ? 1 : 0,
        limitByTimeframe: formData.limitByTimeframe ? 1 : 0,
        timeframe: formData.timeframe,
        count: formData.count,
        resetCount: formData.resetCount ? 1 : 0,
        groupByWorkstation: formData.groupByWorkstation ? 1 : 0,
        groupByUser: formData.groupByUser ? 1 : 0,
        privateAlert: formData.privateAlert ? 1 : 0,
        minSeverity: formData.minSeverity,
        maxSeverity: formData.maxSeverity,
        categories: [...formData.categories],
        words: [...formData.words],
        wordsToAdd: [],
        wordsToDelete: [],
        usernames: [...newUsersArray],
        workstations: [...newWorkstationsArray],
        clonedAlert: 0
      }
      const alertID = editAlertID
      dispatch(updateAlert(alertData, unitID, alertID, fireSuccess, fireFailure))
    }
  }

  const fireSuccess = () => {
    if (editing === false) {
      NotificationToast(false, 'New alert created successfully!')
    } else if (editing === true) {
      NotificationToast(false, 'Alert updated successfully!')
    }
    setFormData({
      emailNotificationName: '',
      emailNotificationDesc: '',
      type: 'S',
      minSeverity: 1,
      maxSeverity: 100,
      keyboard: 1,
      application: 1,
      limitByTimeframe: 0,
      timeframe: 0,
      count: 0,
      resetCount: 0,
      groupByWorkstation: 0,
      groupByUser: 0,
      groupByCategory: 0,
      privateAlert: 1,
      categories: [],
      words: [],
      usernames: [],
      workstations: []
    })
    handleBacktrack()
  }

  const fireFailure = () => {
    if (editing === false) {
      NotificationToast(true, 'Failed to create new alert.')
    } else if (editing === true) {
      NotificationToast(true, 'Failed to update alert.')
    }
  }

  const isEnabled = formData.emailNotificationName.length > 0 && formData.emailNotificationDesc.length > 0

  return (
    <>
      <Grid container direction='column' justify='center'>
        <Grid container direction='row'>
          <Grid item container xs={4} justify='flex-start'>
            <h2 className='mr-3 mb-4'>Build Alerts</h2>
          </Grid>
          <Grid item container xs={4} justify='flex-start'>
            <Button
              variant='contained'
              className={`mb-4 ${classes.greenBtn}`}
              onClick={(e) => { handleBacktrack() }}
            >
              Back
            </Button>
          </Grid>
          <Grid item container xs={4} justify='flex-end'>
            <Button
              variant='contained'
              className={`mb-4 ${classes.blueBtn}`}
              onClick={(e) => handleSave()}
              disabled={!isEnabled}
            >
              Save
            </Button>
          </Grid>
        </Grid>
        <Grid container direction='row' justify='center'>
          <Grid item xs={4}>
            <TreeView expanded={selectedKeys} className={classes.unitTree} disableSelection>
              <UnitTree
                onNodeSelect={handleNodeSelect}
                selectedKeys={[selectedKey]}
                treeData={TreeData}
                expandedKeys={selectedKeys}
                onNodeAugment={handleNodeAugment}
              />
            </TreeView>
          </Grid>

          <Grid container item direction='row' xs={8}>
            <UserBuildAlertsForm
              classes={classes}
              selectedKey={selectedKey}
              StyledSwitch={StyledSwitch}
              AccessSwitch={AccessSwitch}
              CustomSlider={CustomSlider}
              CustomTextField={CustomTextField}
              formData={formData}
              setFormData={setFormData}
              GreenCheckbox={GreenCheckbox}
              marks={marks}
              Categories={Categories}
              UsersList={UsersList}
              WorkstationsList={WorkstationsList}
              editing={editing}
              success={success}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default UserBuildAlerts
